/**
 * Sizing for the terminal's right-rail side-panel mount. The terminal
 * package manages its own internal layout (sessions sidebar, dividers);
 * the host only sizes the panel's outer width, resized by dragging the
 * panel's left edge and persisted per-user.
 */

/** Default outer width — sessions sidebar (280) + a comfortable chat pane. */
export const SIDE_PANEL_DEFAULT_WIDTH = 700;
export const SIDE_PANEL_MIN_WIDTH = 420;
export const SIDE_PANEL_MAX_WIDTH = 1200;

const SIDE_PANEL_WIDTH_STORAGE_KEY_BASE = 'paradigm_terminal_side_panel_width';

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

function sidePanelWidthKey(userId: string): string {
  return `${userId.toLowerCase()}:${SIDE_PANEL_WIDTH_STORAGE_KEY_BASE}`;
}

export function loadSidePanelWidth(userId: string | null): number {
  if (userId == null) return SIDE_PANEL_DEFAULT_WIDTH;
  try {
    const raw = localStorage.getItem(sidePanelWidthKey(userId));
    if (raw == null) return SIDE_PANEL_DEFAULT_WIDTH;
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return SIDE_PANEL_DEFAULT_WIDTH;
    return clamp(parsed, SIDE_PANEL_MIN_WIDTH, SIDE_PANEL_MAX_WIDTH);
  } catch {
    return SIDE_PANEL_DEFAULT_WIDTH;
  }
}

export function persistSidePanelWidth(userId: string, width: number): void {
  try {
    localStorage.setItem(sidePanelWidthKey(userId), String(width));
  } catch {
    // storage unavailable — ignore
  }
}
